import { useSyncExternalStore } from 'react';
import { useSocketMessage } from '../socket/useSocket';
import { getVersionRefreshManager, type VersionStatus } from '@/lib/versionRefresh';

export function useVersionCheck(): void {
  useSocketMessage((msg) => {
    if (msg.type === 'version') {
      getVersionRefreshManager().onVersionMessage(msg.version, msg.commit);
    }
  });
}

export function useVersionStatus(): VersionStatus {
  const manager = getVersionRefreshManager();
  return useSyncExternalStore(manager.subscribe, manager.getSnapshot);
}
